import React from 'react'
import ClosureSurvey from 'sprockets_react/closure_survey/registry'

ClosureSurvey.Header = React.createClass({
  componentDidMount: function() {
    let $jobClosureModal = $('#job-closure-modal');
    $jobClosureModal.find('.modal-header .close').on('click', function() {
      let $warning = $jobClosureModal.find('.close-modal-warning');
      if ($warning.is(':hidden')) {
        $warning.velocity('slideDown');
        $(this).addHidden();
      }
    })
  },
  render: function() {
    return (
      <div className="modal-header survey-header radius-16-top mr32 ml32 p0 pt16 pb16">
        { !['ios', 'android'].includes(this.props.medium) &&
          <button type="button" className="close" aria-label="Close"><span aria-hidden="true" className="ficon-delete font-14" style={{top: '16px', right:'30px', position:'absolute'}}></span></button>
        }
      </div>
    )
  }
})
